import { render, staticRenderFns } from "./SupervisionQualityEthicalSection.vue?vue&type=template&id=1c6a2815&scoped=true"
import script from "./SupervisionQualityEthicalSection.vue?vue&type=script&lang=js"
export * from "./SupervisionQualityEthicalSection.vue?vue&type=script&lang=js"
import style0 from "./SupervisionQualityEthicalSection.vue?vue&type=style&index=0&id=1c6a2815&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a2815",
  null
  
)

export default component.exports